import React, { Suspense } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useGetCurrentUserQuery } from '@/app/services/authApi';
import { useAppSelector } from '@/app/store';
import { selectAuth } from '@/app/features/authSlice';
import Loader from './loader';

interface AuthGuardProps {
  children: React.ReactNode;
  isAuthRequired?: boolean;
}

export function AuthGuard({ children, isAuthRequired = true }: AuthGuardProps) {
  const { user, authStep } = useAppSelector(selectAuth);
  const { isLoading } = useGetCurrentUserQuery();
  const location = useLocation();
  const isAuthPage = location.pathname.startsWith('/auth');

  if (isLoading) {
    return <Loader />;
  }

  if (isAuthRequired && (!user || (user && authStep))) {
    if (!isAuthPage) {
      return <Navigate to="/auth" replace />;
    }
  }

  if (user && !authStep && isAuthPage) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Suspense fallback={<Loader />}>{children}</Suspense>;
}
